<template>
    <modal @close="closeFromModal">
        <h5 slot="header">{{ $tl("labels.clickAndCollect.modals.titles.detailsOrder") }}</h5>
        <div slot="body">
            <invalid-command :command="command" />
        </div>
        <div slot="footer" class="d-flex w-100 justify-content-between">
            <button class="modal-default-button btn-sm btn btn-secondary btn-circle" @click="close">{{ $tl("labels.form.actions.close") }}</button>
        </div>
    </modal>
</template>

<script>
import InvalidCommand from "../../../clickAndCollect/Command/InvalidCommand.vue";

export default {
    props: {
        command: {
            required: true,
        },
    },
    methods: {
        close() {
            this.$emit("close");
        },
        closeFromModal: function (e) {
            if (e && e.target && !e.target.classList.contains("modal-wrapper")) {
                e.stopPropagation();
            } else {
                this.close();
            }
        },
    },
    components: {
        InvalidCommand,
    },
};
</script>
